@use "@flixbus/honeycomb-react/dist/scss/honeycomb-helpers.scss";

.tabsContainer {
  display: flex;
  flex-direction: column;
  gap: var(--hcr-spacing-4);
  padding: var(--hcr-spacing-3) var(--hcr-spacing-4);
  background-color: var(--hcr-bg-primary-color);
}
